import axiosNest from '../../api/axiosNest';

/**
 * Konto giełdowe wspólne spółki — odpowiada `PUT /companies/:id/exchange-account`
 * (odpowiedzi Marathonu/Euvic 16.10.2026, pyt. 18b: „póki co jedno konto;
 * zlecenia z obu spółek mają lądować na giełdzie”). Za przełącznikiem
 * `exchangeBothCompanies` — wyłączony, API odpowiada 404.
 *
 * `accountCompanyId` — spółka, z której kont publikujemy zlecenia tej
 * spółki; `null` = z własnych kont. Powód obowiązkowy (dziennik działań).
 */
export async function saveExchangeAccount(
  companyId: number | string,
  accountCompanyId: number | null,
  reason: string,
): Promise<void> {
  await axiosNest.put(`/companies/${companyId}/exchange-account`, { accountCompanyId, reason });
}

/** Wskazanie z rekordu; brak pola (starsze API) albo NULL = z własnych kont. */
export function exchangeAccountOf(record: Record<string, unknown>): number | null {
  const v = record.exchangeAccountCompanyId;
  return typeof v === 'number' ? v : null;
}

/**
 * Spółki, które można wskazać: nie ta sama i nie taka, która sama publikuje
 * z cudzych kont (bez łańcuchów — jak w API).
 */
export function accountCandidates(
  record: Record<string, unknown>,
  companies: ReadonlyArray<Record<string, unknown>>,
): Array<{ id: number; name: string }> {
  return companies
    .filter((c) => c.id !== record.id && exchangeAccountOf(c) === null && typeof c.id === 'number')
    .map((c) => ({ id: c.id as number, name: typeof c.name === 'string' ? c.name : `spółka nr ${String(c.id)}` }));
}
